module.exports = __webpack_public_path__ + "media/images/icon-search-large-8275a3bc6a72d1f118194508cda8da59.svg";